import {
  Typography,
  List,
  ListItem,
  ListItemAvatar,
  ListItemSecondaryAction,
  Avatar,
  ListItemText,
  Card,
  CardHeader,
  CardContent,
} from "@mui/material";
import getConnectionIcon from "@arelia-utils/helpers/getConnectionIcon";
import SpinnerWrapper from "@arelia-components/ui-atoms/SpinnerWrapper";


type Props = {
  data: { label: string; value: number }[];
  loading: boolean;
};


export default function AvgWatchedTimeList({ data, loading }: Props) {
  return <Card sx={styles.card}>
    <CardHeader
      title="Average Watched Time"
    />
    <CardContent>
      <SpinnerWrapper loading={loading}>
        <List>
          {data.map(({ label, value }, i) => (
            <ListItem key={i} sx={{ px: 0, py: 1 }}>
              <ListItemAvatar sx={{ minWidth: 47 }}>
                <Avatar sx={{ borderRadius: "initial", width: 32, height: 32 }} src={getConnectionIcon(label as any)} />
              </ListItemAvatar>
              <ListItemText
                primary={label}
                primaryTypographyProps={{ variant: "subtitle2", style: { fontSize: 14 } }}
              />
              <ListItemSecondaryAction>
                <Typography
                  variant="subtitle2"
                  color="secondary"
                  sx={{ letterSpacing: "0.1em", fontWeight: 600, fontSize: 12, textTransform: "uppercase" }}
                >
                  {value}s avg. watched time
                </Typography>
              </ListItemSecondaryAction>
            </ListItem>
          ))}
        </List>
      </SpinnerWrapper>
    </CardContent>
  </Card>;
}

const styles = {
  card: {
    gridColumn: "span 6",
    gridRow: "span 6",
  }
};